module.exports = __webpack_public_path__ + "0500f92a462d0cdef313a42b7eb4cb27.jpg";